/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import { loggedUserSelector } from '../../redux/context/selectors';
import Avatar from '../Avatar';
import Card from './index';
import { USER_TYPES_PROPS, USER_TYPES } from '../../constants/props';
import styles from './index.styl';

const UserCard = ({
  className,
  user: { id, avatar, displayableName },
  note,
  size,
  linkType,
  relatedPatientId,
  loggedUser,
  disabled,
  intro,
  additionalIcons,
  ...other
}) => {
  const userAvatar = (
    <Avatar
      {...{ size }}
      children={displayableName}
      src={get(avatar, 'thumbMin')}
    />
  );

  const userData = {
    primary: displayableName,
    complementary: note,
  };

  const isOwnProfile = loggedUser.id === id;
  const adaptedLinkTypeForFamilyMembersOwnProfiles =
    linkType === USER_TYPES.FAMILY_MEMBER ? USER_TYPES.PATIENT : linkType;

  const link =
    relatedPatientId && !isOwnProfile
      ? `/profile/${relatedPatientId}/${linkType}/${id}`
      : `/profile/${id}/${adaptedLinkTypeForFamilyMembersOwnProfiles}`;

  const cardItem = (
    <Card
      {...{ className }}
      {...other}
      additionalContent={{ left: userAvatar }}
      text={userData}
      additionalIcons={additionalIcons}
    />
  );

  const introItem = (
    <If condition={intro && intro.patientName}>
      <span className={intro.patientName} />
    </If>
  );

  if (disabled)
    return (
      <div className="intro-flexWrapper">
        {cardItem}
        {introItem}
      </div>
    );

  return (
    <Link to={link} className="g-hoverable">
      {cardItem}
      {introItem}
    </Link>
  );
};

UserCard.propTypes = {
  className: PropTypes.string,
  user: PropTypes.shape({
    id: PropTypes.number,
    avatar: PropTypes.objectOf(PropTypes.string),
    displayableName: PropTypes.string,
  }),
  note: PropTypes.string,
  size: PropTypes.number,
  linkType: PropTypes.oneOf(USER_TYPES_PROPS),
  relatedPatientId: PropTypes.number,
  loggedUser: PropTypes.shape({
    id: PropTypes.number,
  }),
  disabled: PropTypes.bool,
  intro: PropTypes.shape({
    patientName: PropTypes.string,
  }),
  additionalIcons: PropTypes.array,
};

UserCard.defaultProps = {
  size: 32,
};

const mapStateToProps = state => ({
  loggedUser: loggedUserSelector(state),
});

export default connect(mapStateToProps)(
  CSSModules(UserCard, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Card/UserCard.jsx